import axios from 'axios';
import Vue from 'vue';
export default class {

    constructor(uid, accessToken) {
        this.uid = uid;
        this.accessToken = accessToken;

        let apiBaseURL = '';
        switch (location.host) {
            case 'starlike-test.coolbe.com.tw':
                apiBaseURL = 'https://starlike-test.coolbe.com.tw/api';
                break;
            case 'starlike.coolbe.com.tw':
                apiBaseURL = 'https://starlike.coolbe.com.tw/api';
                break;
            default:
                apiBaseURL = 'https://starlike-test.coolbe.com.tw/api';
                break;
        }
        this.api = axios.create({
            // baseURL: `${location.protocol}//${location.host}/api`,
            baseURL: apiBaseURL,
        });

        this.api.interceptors.response.use(
            config => {
                return config;
            },
            error => {
                let statusCode = error.response?.status;
                let dateObj = new Date(error.response.headers.date);
                let formatDateStr = `${dateObj.getFullYear()}-${dateObj.getMonth()+1}-${dateObj.getDate()} ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`
                let url = error.response.config.url;
                let baseURL = error.response.config.baseURL;


                let errHtml = `<span style="color: #666666;">(${statusCode}) ${baseURL}${url}</span><br/><span>${formatDateStr}</span>`;

                if (!url.includes('/pointRedeem/checkInventory') && !url.includes('/pointRedeem/checkout') && !url.includes('/pointRedeem/products') && !url.includes('/pointRedeem/records')) {
                    Vue.swal({
                        icon: 'error',
                        // title: 'Oops...',
                        html: errHtml,
                    });
                }

                return Promise.reject(error);
            }
        )

    }

    async verify() {
        return await this.api.post(`/client/member/info`, {
            uid: this.uid,
            accessToken: this.accessToken,
        });
    }

    async getProfile() {
        return await this.api.post(`/client/member/getMember`, {
            uid: this.uid,
            accessToken: this.accessToken,
        });
    }

    async getShoppingRecord() {
        return await this.api.post(`/client/member/member_shopping_record`, {
            uid: this.uid,
            accessToken: this.accessToken,
        });
    }

    async getPointHistory() {
        return await this.api.post('/client/member/member_point_history', {
            uid: this.uid,
            accessToken: this.accessToken,
        });
    }

    async updateMember(obj) {
        let params = Object.assign({
            uid: this.uid,
            accessToken: this.accessToken,
        }, obj);
        return await this.api.post(`/client/member/updateMember`, params);
    }

    async getProducts() {
        return await this.api.post(`/pointRedeem/products`, {
            token: this.accessToken,
        });
    }

    async getProductsInfo(seq) {
        return await this.api.get(`/pointRedeem/product/${seq}`, {
            token: this.accessToken,
        });
    }

    async getCheckInventory(obj) {
        let params = Object.assign({
            token: this.accessToken,
        }, obj);
        return await this.api.post(`/pointRedeem/checkInventory`, params);
    }

    async getCheckout(obj) {
        let params = Object.assign({
            token: this.accessToken,
        }, obj);
        return await this.api.post(`/pointRedeem/checkout`, params);
    }

    async getRecords() {
        return await this.api.post(`/pointRedeem/records`, {
            token: this.accessToken,
        });
    }

    async getUserInfo() {
        return await this.api.post(`/pointRedeem/userInfo`, {
            token: this.accessToken,
        });
    }
}